export default __webpack_public_path__ + "static/media/humans.74f7a743.jpg";